import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"bar",rawName:"v-bar"}],staticStyle:{"height":"100%"}},[_c('div',[_c(VContainer,{staticClass:"lighten-5 dashboard"},[(!_vm.showGraph)?_c('DashboardSkeltonLoader'):_c(VRow,[_c(VCol,{staticClass:"px-5 my-5",attrs:{"cols":"12","sm":"12","md":"6"}},[_c(VCard,{staticClass:"mx-auto",attrs:{"tile":""}},[_c(VListItem,{attrs:{"three-line":""}},[_c(VListItemContent,[_c('div',{staticClass:"overline mb-4"},[_vm._v("Books out of stock")]),_c(VListItemTitle,{staticClass:"headline mb-1"},[_vm._v(" "+_vm._s(_vm.bookCard.booksDistributed)+" ")]),_c(VListItemSubtitle,[_vm._v("Total books now in stock "+_vm._s(_vm.bookCard.booksInStock))])],1),_c(VSheet,{staticClass:"text-center dash-board-card-icon",attrs:{"color":"error","elevation":"2","height":"100","width":"100"}},[_c(VRow,{staticStyle:{"height":"100px"}},[_c(VCol,{attrs:{"align-self":"center"}},[_c(VIcon,{attrs:{"size":"90"}},[_vm._v("mdi-book-open-variant")])],1)],1)],1)],1),_c(VCardActions,[_c('router-link',{attrs:{"link":"","to":"/books"}},[_c(VBtn,{staticClass:"ml-2 mb-2",attrs:{"tile":"","color":"success","tabindex":"2"}},[_vm._v(" Show details ")])],1)],1)],1)],1),_c(VCol,{staticClass:"px-5 my-5",attrs:{"cols":"12","sm":"12","md":"6"}},[_c(VCard,{staticClass:"mx-auto",attrs:{"tile":""}},[_c(VListItem,{attrs:{"three-line":""}},[_c(VListItemContent,[_c('div',{staticClass:"overline mb-4"},[_vm._v("Members with dues")]),_c(VListItemTitle,{staticClass:"headline mb-1"},[_vm._v(" "+_vm._s(_vm.dueCard.membersWithDues)+" ")]),_c(VListItemSubtitle,[_vm._v("Total pending dues ₹"+_vm._s(_vm.dueCard.totalDues))])],1),_c(VSheet,{staticClass:"text-center dash-board-card-icon",attrs:{"color":"warning","elevation":"2","height":"100","width":"100"}},[_c(VRow,{staticStyle:{"height":"100px"}},[_c(VCol,{attrs:{"align-self":"center"}},[_c(VIcon,{attrs:{"size":"90"}},[_vm._v("mdi-account-cash")])],1)],1)],1)],1),_c(VCardActions,[_c('router-link',{attrs:{"link":"","to":"/members?withDues=true"}},[_c(VBtn,{staticClass:"ml-2 mb-2",attrs:{"tile":"","color":"success","tabindex":"2"}},[_vm._v(" Show details ")])],1)],1)],1)],1),_c(VCol,{staticClass:"px-5 mb-5 chart-parent",attrs:{"cols":"12","sm":"12","md":"12"}},[_c(VCard,{class:['mx-auto', _vm.showDistribution && 'pr-6'],attrs:{"tile":""}},[_c('div',{staticClass:"chart-wrap"},[_c(VListItem,{attrs:{"three-line":""}},[_c(VListItemContent,[_c('div',{staticClass:"overline my-4 d-flex"},[_c('span',[_vm._v("Books distributions in "+_vm._s(_vm.distributionsYearType === "Day wise" ? (_vm.distributionsMonthString + ", ") : "")+" "+_vm._s(_vm.distributionsYear))]),_c(VSelect,{staticClass:"abstract-filter ml-4",attrs:{"dense":"","items":['Month wise', 'Day wise'],"label":"Type"},on:{"change":_vm.loadDistributionGraph},model:{value:(_vm.distributionsYearType),callback:function ($$v) {_vm.distributionsYearType=$$v},expression:"distributionsYearType"}}),_c(VSelect,{staticClass:"abstract-filter ml-4",attrs:{"dense":"","items":_vm.years,"label":"Year"},on:{"change":_vm.loadDistributionGraph},model:{value:(_vm.distributionsYear),callback:function ($$v) {_vm.distributionsYear=$$v},expression:"distributionsYear"}}),(_vm.distributionsYearType === 'Day wise')?_c(VSelect,{staticClass:"abstract-filter ml-4",attrs:{"dense":"","items":_vm.months,"label":"Month"},on:{"change":_vm.loadDistributionGraph},model:{value:(_vm.distributionsMonth),callback:function ($$v) {_vm.distributionsMonth=$$v},expression:"distributionsMonth"}}):_vm._e(),_c(VSelect,{staticClass:"abstract-filter ml-4",attrs:{"dense":"","clearable":"","items":[
                        'General',
                        'Balavedhi',
                        'Reference',
                        'E-Reader'
                      ],"label":"Distribution Type"},on:{"change":_vm.loadDistributionGraph},model:{value:(_vm.distributionType),callback:function ($$v) {_vm.distributionType=$$v},expression:"distributionType"}})],1)])],1),(!_vm.showDistribution)?_c(VSkeletonLoader,{staticClass:"graph-skeleton-loader",attrs:{"tile":"","height":"285","type":"image"}}):_c('apexchart',{attrs:{"type":"bar","height":"270","options":{
                  colors: ['#15b998'],
                  chart: {
                    offsetX: 3,
                    width: '100%',
                    dropShadow: {
                      enabled: true,
                      color: '#555',
                      top: 5,
                      left: 7,
                      blur: 3,
                      opacity: 0.2
                    },
                    zoom: {
                      enabled: false
                    },
                    toolbar: {
                      show: false
                    }
                  },
                  plotOptions: {
                    bar: {
                      dataLabels: {
                        position: 'top'
                      },
                      barWidth: '10%'
                    }
                  },
                  dataLabels: {
                    enabled: true,
                    style: {
                      colors: ['#000']
                    },
                    offsetY: -18
                  },
                  stroke: {
                    curve: 'straight'
                  },
                  grid: {
                    row: {
                      colors: ['#f3f3f3', 'transparent'],
                      opacity: 0.5
                    }
                  },
                  xaxis: {
                    categories: _vm.distributionsMonthNames
                  },
                  yaxis: {
                    decimalsInFloat: 0,
                    labels: {
                      formatter: function (val) { return (val === Infinity ? ' ' : val); }
                    }
                  }
                },"series":_vm.distributionsSeries}})],1)])],1),_c(VCol,{staticClass:"px-5 mb-5 chart-parent",attrs:{"cols":"12","sm":"12","md":"12"}},[_c(VCard,{staticClass:"mx-auto pr-6",attrs:{"tile":""}},[_c(VListItem,{attrs:{"three-line":""}},[_c(VListItemContent,[_c('div',{staticClass:"overline mb-4"},[_vm._v(" Books which are not yet been returned in the last 12 months ")])])],1),(_vm.showGraph)?_c('apexchart',{attrs:{"type":"bar","height":"270","options":{
                colors: ['#15b998'],
                chart: {
                  offsetX: 3,
                  width: '100%',
                  dropShadow: {
                    enabled: true,
                    color: '#555',
                    top: 5,
                    left: 7,
                    blur: 3,
                    opacity: 0.2
                  },
                  zoom: {
                    enabled: false
                  },
                  toolbar: {
                    show: false
                  }
                },
                plotOptions: {
                  bar: {
                    dataLabels: {
                      position: 'top'
                    },
                    barWidth: '10%'
                  }
                },
                dataLabels: {
                  enabled: true,
                  style: {
                    colors: ['#000']
                  },
                  offsetY: -18
                },
                stroke: {
                  curve: 'straight'
                },
                grid: {
                  row: {
                    colors: ['#f3f3f3', 'transparent'],
                    opacity: 0.5
                  }
                },
                xaxis: {
                  categories: _vm.notRetunedMonthNames
                },
                yaxis: {
                  decimalsInFloat: 0
                }
              },"series":_vm.notRetunedSeries}}):_c(VSkeletonLoader,{staticClass:"graph-skeleton-loader",attrs:{"tile":"","type":"image","height":"285"}})],1)],1)],1)],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }